<template>
  <div
    class="tab-pane"
    id="attendancesettings"
    role="tabpanel"
    aria-labelledby="attendancesettings-tab"
    ref="formContainer"
  >
    <Form @submit="updateAttendanceSettings">
      <div class="input-block mb-3">
        <label class="col-form-label">
          Allow Clock In/Out Without Schedule
          <span class="text-danger">*</span> </label
        ><br />
        <label class="switch">
          <input
            type="hidden"
            name="clockin_clockout_without_schedule"
            v-model="form.clockin_clockout_without_schedule"
            :true-value="1"
            :false-value="0"
          />
          <input
            type="checkbox"
            name="clockin_clockout_without_schedule"
            v-model="form.clockin_clockout_without_schedule"
            :true-value="1"
            :false-value="0"
          />
          <span></span>
        </label>
      </div>
      <div class="submit-section" v-if="hasEditPermission">
        <button class="btn btn-primary submit-btn">Save Changes</button>
      </div>
    </Form>
  </div>
</template>

<script>
import axios from "axios";
import { notification } from "ant-design-vue";
import { Form } from "vee-validate";
export default {
  components: {
    Form,
  },
  data() {
    return {
      form: {
        clockin_clockout_without_schedule: 1,
      },
      hasEditPermission: null,
    };
  },
  methods: {
    updateAttendanceSettings() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .post("/globalsettings/updatevisibilitysettings", this.form)
        .then((response) => {
          loader.hide();
          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
          this.loadAttendanceData();
        })
        .catch((error) => {
          loader.hide();
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });
        });
    },
    loadAttendanceData() {
      var token = window.localStorage.getItem("token");
      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      axios
        .get("/globalsettings/attendancesettings")
        .then((response) => {
          if (response.data.data) {
            this.form.clockin_clockout_without_schedule =
              response.data.data[0].global_settings_value;
          }
        })
        .catch((error) => {
          notification.open({
            message: error.response?.data?.message || "Server Error",
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_WARNING_COLOR,
            },
          });
        });
    },
  },
  mounted() {
    this.$store
      .dispatch("userPermissions", {
        module: "global_setting",
        action: "write",
      })
      .then((response) => {
        this.hasEditPermission = null;
        this.$nextTick(() => {
          this.hasEditPermission = response === "true";
        });
      });

    this.loadAttendanceData();
  },
};
</script>
